import axios from "axios";
import config from "./config";

export const oauthAuthorize = (params) => {
  return axios.get("/oauth/authorize", {
    ...config,
    params,
  });
}
